import {WixSdk} from '@wix/js-sdk-wrapper';
import {Player} from '@wix/music-player';

export function subscribeOnPlayerEventsToGetWindow(player: Player) {
  player.on('playing', (trackId) => {
    WixSdk.PubSub.publish('remote-player.state-update.playing', {trackId});
  });

  player.on('pause', (trackId) => {
    WixSdk.PubSub.publish('remote-player.state-update.pause', {trackId});
  });

  player.on('timeupdate', (currentTime, progress, trackId) => {
    WixSdk.PubSub.publish('remote-player.state-update.timeupdate', {trackId, currentTime});
  });

  player.on('player.error', (name) => {
    WixSdk.PubSub.publish('remote-player.state-update.error', {name});
  });
}
